import {
  Component,
  input,
  ChangeDetectionStrategy,
  viewChild,
} from '@angular/core';
import { Popover } from 'primeng/popover';
import { Ag1ButtonSmallComponent } from '../ag1-button-small/ag1-button-small.component';
import { Bind } from 'primeng/bind';
import { Button } from 'primeng/button';
import { Tooltip } from 'primeng/tooltip';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'ag1-info',
  templateUrl: './ag1-info.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    Ag1ButtonSmallComponent,
    Bind,
    Popover,
    Button,
    Tooltip,
    AngularSvgIconModule,
  ],
})
export class Ag1InfoComponent {
  // allows you to change the trigger color
  // in the future you could use it to change the panel appearance as well
  readonly variant = input<
    'primary' | 'secondary' | 'tertiary' | 'danger' | 'success'
  >('primary');

  readonly heading = input<string>('Replace this with your title');

  readonly body = input<string>(
    'Replace this with your body text. You can use this to provide more information to the user.',
  );

  readonly infoPopover = viewChild.required<Popover>('infoPopover');

  constructor() {}

  closePanel(): void {
    this.infoPopover().hide();
  }
}
